import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToolbarModule } from 'primeng/toolbar';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { HttpClient } from '@angular/common/http';
import { RoleAccessService } from '../auth/role-access.service';
import { UserRole } from '../auth/roles.enum';
import { AppFeature } from '../auth/features.enum';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../environments/environment';
interface RoleGroup {
  id: number;
  name: string;
  description: string;
  isActive: string ;  // now number or null
}

@Component({
  selector: 'app-manage-role',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    TagModule,
    ToolbarModule,
    RippleModule,
    ToastModule,
    ConfirmDialogModule,
    RadioButtonModule,
    IconFieldModule,
    InputIconModule,
    TableModule,
    AutoCompleteModule
  ],
  templateUrl: './manage-role-group.component.html',
  styleUrls: ['./manage-role-group.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ManageRoleGroupComponent implements OnInit, OnDestroy {
  roleGroups: RoleGroup[] = [];
  selectedRoles: RoleGroup[] = [];
  roleDialog: boolean = false;
  submitted: boolean = false;
  editingRoleId: number | null = null;

  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    // Signal all observables to complete and clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
    console.log('ManageRoleGroupComponent destroyed');
  }

  roleForm = {
    name: '',
    description: '',
    isActive: '',  // number or null (no status selected)
  };

  private roleIdCounter = 1;

constructor(
  private messageService: MessageService,
  private confirmationService: ConfirmationService,
  private http: HttpClient,
  private roleAccessService: RoleAccessService,
  private router: Router
) {}
 canAccess = false;
ngOnInit(): void {
      const userRoles: UserRole[] = JSON.parse(localStorage.getItem('roleGroup') || '[]');
      console.log('Loaded userRoles:', userRoles);
      
  this.canAccess = this.roleAccessService.hasAccess(userRoles, AppFeature.UserManagement);
if (this.canAccess) {
    this.router.navigate(['/Orders1']);
    return;
}
  this.http.get<any>(`${environment.authApiUrl}role-groups`).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res) => {
      if (res && Array.isArray(res.rolegroups)) {
        this.roleGroups = res.rolegroups.map((group: any) => ({
          id: group.id,
          name: group.name,
          description: group.description,
          isActive: group.status // Use status from API as isActive
        }));
        localStorage.setItem('roleGroups', JSON.stringify(this.roleGroups));
      } else {
        this.roleGroups = [];
      }
    },
    error: (err) => {
      // Optionally show a message and fallback to empty or static data
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load role groups from server.',
        life: 3000
      });
      this.roleGroups = [];
    }
  });
}
    goBack() {
        this.router.navigate(['/registered-user']);
    }
  openNew(): void {
    this.submitted = false;
    this.roleDialog = true;
    this.editingRoleId = null;
    this.roleForm = {
      name: '',
      description: '',
      isActive: '' // No default selected
    };
  }

  hideDialog(): void {
    this.roleDialog = false;
    this.submitted = false;
  }

  saveRole(): void {
    this.submitted = true;

    const { name, description, isActive } = this.roleForm;

    if (!name || !description) return;

    if (this.editingRoleId !== null) {
      const index = this.roleGroups.findIndex(r => r.id === this.editingRoleId);
      if (index !== -1) {
        this.roleGroups[index] = {
          id: this.editingRoleId,
          name,
          description,
          isActive
        };
        this.messageService.add({
          severity: 'success',
          summary: 'Updated',
          detail: 'Role group updated successfully',
          life: 3000
        });
      }
    } else {
      this.roleGroups.push({
        id: this.roleIdCounter++,
        name,
        description,
        isActive
      });
      this.messageService.add({
        severity: 'success',
        summary: 'Created',
        detail: 'Role group added successfully',
        life: 3000
      });
    }

    localStorage.setItem('roleGroups', JSON.stringify(this.roleGroups));
    this.roleDialog = false;
  }

  editRole(role: RoleGroup): void {
    this.roleForm = {
      name: role.name,
      description: role.description,
      isActive: role.isActive
    };
    this.editingRoleId = role.id;
    this.roleDialog = true;
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  deleteRole(role: RoleGroup): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete "${role.name}"?`,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.roleGroups = this.roleGroups.filter(r => r.id !== role.id);
        localStorage.setItem('roleGroups', JSON.stringify(this.roleGroups));
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Role group deleted successfully',
          life: 3000
        });
      }
    });
  }

 statusOptions = [
  { label: 'Active', value: 10 },
  { label: 'Inactive', value: 20 }
];

filteredStatus: { label: string; value: number }[] = [];

filterStatus(event: { query: string }): void {
  const query = event.query.toLowerCase();
  this.filteredStatus = this.statusOptions.filter(option =>
    option.label.toLowerCase().includes(query)
  );
}

getStatusLabel(value: number | null): string {
  const status = this.statusOptions.find(s => s.value === value);
  return status ? status.label : 'No Status';
}
// Example data for autocomplete suggestions
roleNameOptions = [
  { name: 'Admin' },
  { name: 'User' },
  { name: 'Manager' },
  { name: 'Guest' },
  // add more as needed
];

descriptionOptions = [
  { description: 'Full access' },
  { description: 'Limited access' },
  { description: 'Read-only' },
  { description: 'Temporary' },
  // add more as needed
];

filteredRoleNames: any[] = [];
filteredDescriptions: any[] = [];

filterRoleNames(event: { query: string }) {
  const query = event.query.toLowerCase();
  this.filteredRoleNames = this.roleNameOptions.filter(option =>
    option.name.toLowerCase().includes(query)
  );
}

filterDescriptions(event: { query: string }) {
  const query = event.query.toLowerCase();
  this.filteredDescriptions = this.descriptionOptions.filter(option =>
    option.description.toLowerCase().includes(query)
  );
}

}
